module.exports = __webpack_public_path__ + "img/background.a0e1200f.png";